import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

const routes = [
  {
    name: 'companyHome',
    component: () => import('./view/companyHome'),
    meta: {
      title: '企业报名',
      showBottom: true,
      keepAlive: true,
      bottomName: 'companyHome',
    },
  },
  {
    name: 'governmentHome',
    component: () => import('./view/governmentHome'),
    meta: {
      title: '政党机关报名',
      showBottom: true,
      keepAlive: true,
      bottomName: 'governmentHome',
    },
  },
  {
    name: 'sucesssPage',
    component: () => import('./view/sucesssPage'),
    meta: {
      title: '提交成功',
      showBottom: true,
      keepAlive: true,
      bottomName: 'sucesssPage',
    },
  },
  {
    name: 'errorPage',
    component: () => import('./view/errorPage'),
    meta: {
      title: '提交失败',
      showBottom: true,
      keepAlive: true,
      bottomName: 'errorPage',
    },
  },
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

const router = new Router({ mode: 'history', base: '/tzgd/hdbm/mobile/', routes });

router.beforeEach((to, from, next) => {
  next();
});

export { router };
